import { riskGradePalette } from '@innovyze/stylovyze';

export const riskGradeColours = [
	riskGradePalette.negligible.dark,
	riskGradePalette.low.dark,
	riskGradePalette.medium.main,
	riskGradePalette.high.main,
	riskGradePalette.extreme.dark,
];

export const riskGradeLayerNames = [
	'Optimal',
	'Stable',
	'Moderate',
	'Concerning',
	'Critical',
];

export const useLayerConfig = (configId: string) => {
	const layers = [0, 1, 2, 3, 4].map(n => ({
		layerName: riskGradeLayerNames[n],
		id: `risk${configId}-${n}`,
		dataServiceId: `Risk/${configId}`,
		type: 'line',
		color: riskGradeColours[n],
		properties: {
			riskGrade: [n - 0.5, n + 0.5],
		},
		selectable: false,
	}));

	return [
		{
			layerName: 'Risk levels',
			dataServiceId: 'tiled-risk',
			tileSource: `Risk/${configId}`,
			tileLayerName: configId.replaceAll('-', ''),
			layers,
		},
	];
};
